import { render, staticRenderFns } from "./SntOverlayLoading.vue?vue&type=template&id=0349e652&"
import script from "./SntOverlayLoading.vue?vue&type=script&lang=js&"
export * from "./SntOverlayLoading.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports